// import React from 'react';

// type Props = {
//   word: string;
// };

// const WordCard: React.FC<Props> = ({ word }) => {
//   return (
// <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-3 text-center w-32 h-16 flex items-center justify-center">
//   <p className="text-lg font-semibold text-gray-800">{word}</p>
// </div>

//   );
// };

// export default WordCard;

interface WordCardProps {
  word: string;
  onClick?: (word: string) => void;
}

const WordCard: React.FC<WordCardProps> = ({ word, onClick }) => {
  return (
    <div
      className="bg-white border border-gray-200 rounded-xl shadow-sm p-3 text-center w-32 h-16 cursor-pointer flex items-center justify-center"
      onClick={() => onClick?.(word)}
    >
      <p className="text-base font-semibold text-gray-800">{word}</p>
    </div>
  );
};

export default WordCard;

